export enum OrderStatusType {
  Ready = 'READY',
  RequestPickup = 'REQUEST_PICKUP',
  WaitingPayment = 'WAITING_PAYMENT',
  Cancel = 'CANCEL',
  RequestedCancel = 'REQUESTED_CANCEL',
  PickupCheck = 'PICKUP_CHECK',
  PickupComplete = 'PICKUP_COMPLETE',
  PickupCancel = 'PICKUP_CANCEL',
  RedirectPreparing = 'REDIRECT_PREPARING',
  PartnershipPickupCheck = 'PARTNERSHIP_PICKUP_CHECK',
  PrescriptionApproved = 'PRESCRIPTION_APPROVED',
  PrescriptionDenied = 'PRESCRIPTION_DENIED',
  PartnershipPickupRequest = 'PARTNERSHIP_PICKUP_REQUEST',
  ImmediateOrder = 'ImmediateOrder'
}

export interface ReadyStatusAgreements {
  isCheckedDur: boolean;
  isCheckedAlternative?: boolean;
}

export enum EAlternativeOption {
  SoldOut = 'SOLD_OUT',
  Cheaps = 'CHEAPS',
  MANUAL = 'MANUAL'
}

export enum EUpdateOrderPriceOption {
  WRONG_PRICE = 'WRONG_PRICE',
  PRESCRIPTION_CHANGE = 'PRESCRIPTION_CHANGE',
  MANUAL = 'MANUAL'
}

export interface UpdateOrderPriceForm {
  orderId?: number;
  reason?: string;
  reasonType: EUpdateOrderPriceOption;
  price?: string;
}
